var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body } from 'syf-component-library/ui/typography';
import { NoMembersFoundContainer } from './subcomponents';
import { translate } from '../../../strings/i18n';
import SamsSteps from '../SamsSteps';
var NoEligibleMembersFound = function () { return (_jsxs(NoMembersFoundContainer, __assign({ top: "xlarge", bottom: "medium", vertical: "medium" }, { children: [_jsx(Body, __assign({ weight: "bold" }, { children: translate('noEligibleMembersFound') })), _jsx(SamsSteps, { title: translate('steps.title') })] }))); };
export default NoEligibleMembersFound;
